<template>
  <!-- if color -->
  <span
    @click="() => addToSelectedAttributes(child)"
    v-if="child.color"
    aria-labelledby="choose a color"
    aria-label="choose a color"
    :title="`${!isSelected ? $t('general.select_noun') : ''} ${child[finalizedNameKey]}`.trim()"
    class="w-[1.380rem] h-[1.380rem] md:w-[1.4rem] md:h-[1.4rem] 3xl:w-[1.438rem] 3xl:h-[1.438rem] rounded-full overflow-hidden lg:w-[27px] lg:h-[27px]"
    :style="child.color && isWhiteColor(child.color) ? { border: '1.5px solid #dddd', boxShadow: '0 0 0 2px #8883' } : {}"
  >
    <span 
      :style="{ backgroundColor: child.color }" 
      class="inline-block w-full h-full rounded-full"
    ></span>
    <span class="sr-only">choose a color</span>
  </span>
  <!-- else -->
  <span
    v-else
    aria-labelledby="choose an attribute"
    aria-label="choose an attribute"
    :title="`${!isSelected ? $t('general.select_noun') : ''} ${child[finalizedNameKey]}`.trim()"
    @click="() => addToSelectedAttributes(child)"
    class="bg-[#E3F2FD] text-primary py-1.5 px-3 rounded-lg border border-[#BBDEFB] transition-all duration-150 cursor-pointer hover:bg-[#BBDEFB] active:scale-[0.95] whitespace-nowrap"
    :class="{ 'ring-2 ring-primary ring-offset-1 bg-[#BBDEFB]': isSelected }"
  >{{ child[finalizedNameKey] }}</span>
</template>

<script>
export default {
    setup(){
        const usedCookieLanguage = useCookie('localStorageCopy')?.value?.language || 'ar';
        return {
            usedCookieLanguage
        }
    },
    props: {
        selectedAttributes: {
            type: Object,
            required: true,
            default: () => ({})
        },
        addToSelectedAttributes: {
            type: Function,
            required: true,
        },
        child: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    computed: {
        isSelected(){
            return this.selectedAttributes && Object.keys(this.selectedAttributes || {}).map(key => this.selectedAttributes[key]).some(attr => attr.id === this.child.id);
        },
        finalizedNameKey(){
            return this.nameKey || `name_${this.usedCookieLanguage}`;
        }
    },
    methods: {
        isWhiteColor(color){
            return typeof color === 'string' && color.trim().toLowerCase() === '#ffffff';
        }
    }
};
</script>

<style>
</style>